import React from 'react'

export default function TermsOfService() {
    return (
        <div className="container mx-auto p-6 px-2 md:px-20">
            <div className="rounded-lg p-6 md:p-12">
                <h1 className="text-3xl font-bold mb-8 text-left">Uslovi korištenja</h1>
                <p className="mb-4 text-footerBlue text-left text-xl">
                    Dobrodošli na IgraoniceBL, online platformu za zakazivanje rođendanskih proslava u raznim rođendaonicama širom grada. Korištenjem ove platforme, saglasni ste sa sljedećim uslovima:
                </p>

                <h2 className="text-xl mb-2 text-footerBlue text-left">1. Pružanje usluge</h2>
                <p className="mb-4 text-footerBlue text-left text-xl">
                    IgraoniceBL djeluje isključivo kao posrednik između korisnika i rođendaonica. Naša platforma omogućava jednostavan način pregledanja i zakazivanja rođendanskih proslava, ali mi ne upravljamo niti vodimo rođendaonice koje su navedene na našoj stranici. Odgovornost za isporuku usluga koje su dogovorene prilikom zakazivanja isključivo je na rođendaonici.
                </p>

                <h2 className="text-xl mb-2 text-footerBlue text-left">2. Odgovornost</h2>
                <p className="mb-4 text-footerBlue text-left text-xl">
                    IgraoniceBL nije odgovorna za bilo kakve incidente, neprijatnosti ili štetu koja može nastati tokom rođendanskih proslava ili kao rezultat usluga koje pružaju rođendaonice. Ovo uključuje, ali nije ograničeno na:
                </p>

                <ul className="list-disc text-xl pl-6 mb-2 text-footerBlue text-left">
                    <li>Povrede, nesreće ili druge zdravstvene probleme.</li>
                    <li>Nezadovoljavajuću uslugu ili kvalitet prostora.</li>
                    <li>Otkazivanja, kašnjenja ili promjene u dogovorenim aranžmanima od strane rođendaonice.</li>
                    <li>Bilo koji drugi sporovi koji mogu nastati između korisnika i operatera rođendaonica.</li>
                </ul>

                <h2 className="text-xl mb-2 text-footerBlue text-left">3. Odgovornost korisnika</h2>
                <p className="mb-4 text-footerBlue text-left text-xl">
                    Korisnici su obavezni pažljivo proučiti pravila i uslove rođendaonice prije nego što izvrše zakazivanje. Korištenjem naše platforme, korisnici prihvataju sve rizike povezane s uslugama koje pružaju rođendaonice.
                </p>

                <h2 className="text-xl mb-2 text-footerBlue text-left ">4. Rješavanje sporova</h2>
                <p className="mb-4 text-footerBlue text-left text-xl">
                    Svi sporovi ili zahtjevi vezani za usluge koje pružaju rođendaonice moraju se rješavati direktno između korisnika i operatera rođendaonice. igraoniceBL nije odgovorna za posredovanje niti rješavanje takvih sporova.
                </p>

                <h2 className="text-xl mb-2 text-footerBlue text-left">5. Izmjene platforme</h2>
                <p className="text-footerBlue text-left text-xl">
                    IgraoniceBL zadržava pravo da u bilo kojem trenutku bez prethodne najave izmijeni ili prekine pružanje svojih usluga.
                </p>

                <p className="mt-8 text-footerBlue text-left text-xl">
                    Korištenjem igraoniceBL platforme, prihvatate ove uslove i potvrđujete da platforma nije odgovorna za bilo kakve neprijatnosti koje mogu proisteći iz usluga rođendaonica.
                </p>
            </div>
        </div>
    );

}
